import { Action, ActionType, PageLoadedData } from "app/pages/Products/actionTypes";
import { ProductsListState } from './state'

const startingState: ProductsListState = {
    searchTerm: '',
    selectedProductType: 'Accommodation',
    data: undefined,
    filteredData:undefined,
    accommodationProducts:[],
    courseProducts:[],
    addOnProducts:[],
    packageProducts:[],
    feesProducts: [],
    cancellationFeeProducts: [],
    transferProducts:[],
    courseProduct: undefined,
    packageProduct: undefined,
    courseIntensity:[],
    productDivisions:[],
    name:'',
    intensityId:0,
    divisionId:0,
    accommodation:undefined,
    transfer:undefined,
    addon:undefined,
    formErrors: [],
    accommodationTypes:[],
    unitTypes:[],
    transferTypes:[],
    transferPorts:[],
    productCategories: [],
    accountCategories: [],
    commissionCategories: [],
    languages: [],
    types: {},
    draftPackageProduct: undefined,
}

export function reducer(state: ProductsListState|undefined, action: Action) : ProductsListState {
    if(!state)
        return startingState;

    switch(action.type){
        case ActionType.PageLaded:
            return {
                ...startingState,
                formErrors: action.formErrors,
                courseIntensity: action.courseIntensity,
                productDivisions: action.productDivisions,
                accommodationTypes: action.accommodationTypes,
                unitTypes: action.unitTypes,
                transferTypes: action.transferTypes,
                transferPorts: action.transferPorts,
                productCategories: action.productCategories,
                accountCategories: action.accountCategories,
                commissionCategories: action.commissionCategories,
                languages: action.languages
            };
        case ActionType.ChangeSelectedProductType:
            return { ...state, selectedProductType: action.selectedProductType};
        case ActionType.ChangeSearchTerm:
            return {...state, searchTerm: action.searchTerm};
        case ActionType.FilterData:
            return {...state, filteredData: action.filteredData};
        case ActionType.ListAccommodationProductsData:
            return {...state, accommodationProducts: action.accommodationProducts};
        case ActionType.ListCoursesData:
            return {...state, courseProducts: action.courseProducts.map(item => ({ ...item })) /*force new reference*/ };
        case ActionType.GetCourseProductData:
            return {...state, courseProduct: action.courseProduct};
        case ActionType.ListAddOns:
            return {...state, addOnProducts: action.addOnsProducts};
        case ActionType.ListFees:
            return {...state, feesProducts: action.feesProducts};
        case ActionType.ListCancellationFees:
            return {...state, cancellationFeeProducts: (action as any).cancellationFeeProducts};
        case ActionType.ListTransfers:
            return {...state, transferProducts: action.transferProducts};
        case ActionType.ListPackages:
            return {...state, packageProducts: action.packageProducts};
        case ActionType.SetCourseProductIntensity:
            return {...state, intensityId: action.id};
        case ActionType.SetCourseProductName:
            return {...state, name: action.name};
        case ActionType.SetCourseDivision:
            return {...state, divisionId: action.id};
        case ActionType.GetCourseProductName:
            return {...state, name: action.name};
        case ActionType.GetAccommodationProduct:
            return {...state, accommodation: action.accommodation,draftProduct:action.accommodation};
        case ActionType.GetTransferProduct:
            return {...state, transfer: action.transfer};
        case ActionType.GetAddonProduct:
            return {...state, addon: action.addon};
        case ActionType.GetPackageProduct:
            return {...state, packageProduct: action.packageProduct, draftPackageProduct: action.packageProduct};
        case ActionType.CancelShowDeleteCourseAction:
            return {...state,courseProduct: undefined};
        case ActionType.CancelShowDeleteAccommodationAction:
            return {...state,accommodation: undefined};
        case ActionType.CancelShowDeletePackageAction:
            return {...state, packageProduct: undefined, draftPackageProduct: undefined};
        case ActionType.SetFormErrors:
            return { ...state, formErrors: action.formErrors};
        case ActionType.UpdateDraftAccommodationProduct:  
                return { ...state, draftProduct: action.draftProduct};            
        case ActionType.LoadDraftAccommodationProduct:
            return { ...state, draftProduct: action.draftProduct};
        case ActionType.CancelShowDeleteAddOnAction:
            return {...state,addon: undefined};
        case ActionType.CancelShowDeleteTransferAction:
            return {...state, transfer: undefined, draftTransferProduct: undefined};
        case ActionType.UpdateDraftAddOnProduct:  
            return { ...state, draftAddOnProduct: action.draftProduct};            
        case ActionType.LoadDraftAddOnProduct:
            return { ...state, draftAddOnProduct: action.draftProduct};
        case ActionType.UpdateDraftTransferProduct:  
            return { ...state, draftTransferProduct: action.draftProduct};            
        case ActionType.LoadDraftTransferProduct:
            return { ...state, draftTransferProduct: action.draftProduct};
        case ActionType.UpdateDraftPackageProduct:
            return {...state, draftPackageProduct: action.draftProduct};
        case ActionType.LoadDraftPackageProduct:
            return {...state, draftPackageProduct: action.draftProduct};
        case ActionType.GetCancellationFeeProduct:
            return {...state, draftCancellationFeeProduct: (action as any).cancellationFee};
        case ActionType.CancelShowDeleteCancellationFeeAction:
            return {...state, draftCancellationFeeProduct: undefined};
        case ActionType.UpdateDraftCancellationFeeProduct:
            return {...state, draftCancellationFeeProduct: (action as any).draftProduct};
        case ActionType.LoadDraftCancellationFeeProduct:
            return {...state, draftCancellationFeeProduct: (action as any).draftProduct};
        default:
            return state;
    }
}

export const reducers = {
    reducer
};